import { Component, OnInit } from '@angular/core';

import { CustomIcon, IconLibrary, SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { LoaderTheme } from '@fcom/ui-components/components/loader';
import { ConfigService } from '@fcom/core/services';
import { WindowRef } from '@fcom/core/providers';

@Component({
  selector: 'fin-chooose-redirector',
  templateUrl: './chooose-redirector.component.html',
  styleUrls: ['./chooose-redirector.component.scss'],
})
export class ChoooseRedirectorComponent implements OnInit {
  protected readonly IconLibrary = IconLibrary;
  protected readonly CustomIcon = CustomIcon;
  protected readonly SvgLibraryIcon = SvgLibraryIcon;
  protected readonly LoaderTheme = LoaderTheme;

  readonly REDIRECT_TIME = 5000;

  constructor(
    private configService: ConfigService,
    private windowRef: WindowRef
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.windowRef.nativeWindow.location.href = this.configService.cfg.corporateChoooseUrl;
    }, this.REDIRECT_TIME);
  }
}
